// extracted by mini-css-extract-plugin
export var box = "_4k-1";
export var checked = "_4k-2";
export var descriptionSpacer = "_4k-9";
export var disabled = "_4k-3";
export var icon = "_4k-6";
export var input = "_4k-0";
export var labelSpacer = "_4k-8";
export var medium = "_4k-5";
export var small = "_4k-4";
export var text = "_4k-7";